import { useContext } from 'react';

import { moduleContext } from '../../showcase-include';
import { getPostman } from '../../showcase-inject';
import { Postman } from '../../showcase-inject/types';

import { ModuleContext } from './context';

/**
 * @description This hook provides access to the postman instance
 * @return postman
 */
export function usePostman(): Postman | null {
  const name = useContext(ModuleContext);
  const staticPostman = getPostman();

  const ctx = moduleContext(`module_${name}`);

  if (staticPostman) {
    return staticPostman;
  }

  if (ctx) {
    return ctx.postman;
  }

  return null;
}
